import $ from 'jquery';
import React, { Fragment } from 'react';
import classNames from 'classnames';

import { getTileHoverDisplayText } from './grid_tile_hover.jsx';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

// this was only introduced in accessible viewers
const GridTileLinkTapTarget_ViewerVersion1 = ()=> {
  return null;
};


const GridTileLinkTapTarget_ViewerVersion2 = ({
  tileLinkTarget, 
  tileLinkHref, 
  tileActionIndicatorType,
  captionHtml,
  doesTileLinkToVideo, 
  doesOpenOverlay,
  shouldShowExternalOpeningMsg,
  onOverlayOpen,
  onLinkToVideoClick
})=> {
  const ChildComponent = ()=> (
    <Fragment>
      <span aria-hidden="true" className="grid-tile-link-tap-target" />

      {
        tileActionIndicatorType ?
          <VisuallyHiddenSpan>
            { getTileHoverDisplayText(tileActionIndicatorType) }
          </VisuallyHiddenSpan>
        :
          <VisuallyHiddenSpan>
            Open overlay
          </VisuallyHiddenSpan>
      }

      {
        captionHtml &&
          <VisuallyHiddenSpan>
            { $(`<div>${captionHtml}</div>`).text() }
          </VisuallyHiddenSpan>
      }
    </Fragment>
  );

  // this includes:
  //  - web preview tiles
  //  - internal links
  //  - external links
  if (tileLinkHref) {

    return (
      <a 
        href={tileLinkHref}
        className={classNames('grid-tile-link-tap-target-link', {
          'zf-external-link': shouldShowExternalOpeningMsg
        })}
        target={tileLinkTarget} 
        onClick={doesTileLinkToVideo ? onLinkToVideoClick : null}
      >
        <ChildComponent />

        {
          shouldShowExternalOpeningMsg &&
            <span className="opens-in-external-view-wrapper">
              Opens in a new window
            </span>
        }
      </a>
    );

  // this handles just the overlay opening. in previous viewer versions this
  // was handled by an anchor link which wrapped the entirety of a tile which
  // is both not semantic HTML and also not accessible.
  } else if (doesOpenOverlay) {

    return (
      <button
        className="grid-tile-link-tap-target-link"
        onClick={(e)=>{ 
          getTracker().handleTileClick(e);
          e.preventDefault();
          onOverlayOpen();
        }}
      >
        <ChildComponent />
      </button>
    );

  }

  return null;
};

const GridTileLinkTapTarget = (props)=> (
  <SiteViewerVersionComponentSelector>
    <GridTileLinkTapTarget_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <GridTileLinkTapTarget_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

GridTileLinkTapTarget.defaultProps = {
  doesTileLinkToVideo: false
};

export default GridTileLinkTapTarget;
